/**
 * @param {Array<{ id?: string }>|null|undefined} registers
 * @returns {string} UUID prvog registra ili prazan string
 */
export function getFirstRegisterId(registers) {
  if (!Array.isArray(registers) || registers.length === 0) return '';
  const first = registers[0];
  const id = first?.id;
  return id != null ? String(id) : '';
}
